import {
    RESET_SKILLS,
    GET_SKILLS,
    SET_SKILLS,
    API_ERROR,
    GET_SKILL,
    SET_SKILL,
  } from "./actionTypes";

  export const resetSkills = () => {
    return {
      type: RESET_SKILLS,
      payload: {},
    };
  };
  export const getSkills = (idCompany, page, qnt) => {
    return {
      type: GET_SKILLS,
      payload: { idCompany, page, qnt },
    };
  };
  
  export const loadSkills = (data, qtdDefault) => {
    const maxPage = Math.ceil(data.total / qtdDefault);
    var paging = Array.from({ length: maxPage }, (v, k) => k + 1);
  
    return {
      type: SET_SKILLS,
      payload: { ...data, paging },
    };
  };
  
  export const apiError = (error) => {
    return {
      type: API_ERROR,
      payload: error,
    };
  };

  export const getSkill = (idCompany, idSkill) => {
    return {
      type: GET_SKILL,
      payload: { idCompany, idSkill },
    };
  };
  export const setSkill = (data) => {
    return {
      type: SET_SKILL,
      payload: { data },
    };
  };